<template>
    <div>

        <span class="timeline-key">Remarks :  </span>: {{extra.remarks}} <br>
        <span class="timeline-key">Approved by :  </span>: {{user.name}} <br>
        <span class="timeline-key">Attachements:</span>
        <v-layout row wrap>
            <v-flex xs4 v-for="attachment in extra.attachments">
                <file-display :src="attachment"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "VisaPlanUpgradeApproved",
        props: ['extra', 'user'],
        components: {
            FileDisplay
        }
    }
</script>
